
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class FlashMessage extends Vue {
  @Prop({ type: Boolean })
  public value!: boolean

  @Prop({ type: String, default: 'dark' })
  public type!: string

  @Prop({ type: String, default: 'Saved!' })
  public text!: string

  @Prop({ type: Number, default: 1500 })
  public timeout!: number

  get open () {
    return this.$props.value
  }

  set open (value: boolean) {
    this.$emit('input', value)
  }
}
